module.exports = __webpack_public_path__ + "img/sec.a4894d50.svg";